import {Component, Input, ViewEncapsulation} from '@angular/core';
import {MatDialog, PageEvent} from "@angular/material";
import {kanTermsService} from "../../../../services/services/terms";
import {Term} from "../../../../../classes/term";
import {kanTermDialog} from "../../../dialogs/term-dialog/component";

@Component({
    selector: 'kan-terms',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanTerms {
    @Input() selectedTab: number;
    public terms: Term[];
    public filteredTerms: Term[];
    public pagedTerms: Term[];
    public search: string;
    public pageIndex: number = 0;
    public pageSize: number = 20;

    constructor(private dialog: MatDialog, private termsService: kanTermsService) {

    }

    ngOnInit(): void {

    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 2) {
            this.getTerms();
        }
    }

    public getTerms(): void {
        this.termsService.getTerms()
            .then((terms) => {
                this.terms = terms;
                this.filter();
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanTermDialog, {
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getTerms();
            }
        });
    }

    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.pageTerms();
    }

    pageTerms() {
        this.pagedTerms = this.filteredTerms.slice(this.pageIndex * this.pageSize, (this.pageIndex + 1) * this.pageSize);
    }

    public filter() {
        this.filteredTerms = this.terms.filter((term) => {
            let found = true;

            if (this.search) {

                let arr = this.search.split(' ');

                arr.forEach((item) => {

                    if (item) {
                        found = found &&
                            (
                                String(term.name).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1 ||
                                String(term.body).toLowerCase().indexOf(item.toLocaleLowerCase()) > -1
                            );
                    }
                });
            }

            return found;
        });

        this.pageTerms();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/term/terms/component.ts